const pbFontFamily = [
    'Arimo',
    'Barlow',
    'Cabin',
    'Dosis',
    'Fira Sans',
    'Inconsolata',
    'Inter',
    'Lora',
    'Montserrat',
    'Mulish',
    'Open Sans',
    'Oswald',
    'Playfair Display',
    'Quicksand',
    'Raleway',
    'Roboto',
    'Source Sans Pro',
    'Work Sans',
];
const pbFontWeight = {
    regular: 400,
    medium: 500,
    bold: 700,
};
const fontWeightQueryParams = Object.values(pbFontWeight).join(';');
const fontQueryParams = pbFontFamily
    .map((font) => {
    return `family=${encodeURIComponent(font)}:wght@${fontWeightQueryParams}`;
})
    .join('&');

export { fontQueryParams, pbFontFamily, pbFontWeight };
